
import TransferEPinReport from "../../Component/EPin/TransferEpin";
const TransferEPinPage = () => {
  return (
    <div className='page-body'>
      <TransferEPinReport />
    </div>
  )
}

export default TransferEPinPage